import * as React from "react";
import styled from "styled-components";
import * as CSS from 'csstype';
import { SpacesSizes } from "./types";

const StyledSpace = styled.div`
  display: flex;
  align-items: center;
  &.small {
    gap: 8px;
  }
  &.medium {
    gap: 16px;
  }
  &.large {
    gap: 24px;
  }
  `;
StyledSpace.displayName = "StyledSpace";

export interface ISpaceProps {
  style?: CSS.Properties;
  children: JSX.Element;
  gap?: SpacesSizes;
}

export function Space({
  style,
  children,
  gap = "small"
}: ISpaceProps
): JSX.Element {
  return <StyledSpace className={gap} style={style}>{children}</StyledSpace>
}